import { HttpErrorResponse } from '@angular/common/http';
import { Component, Input } from '@angular/core';
import { Store } from '@ngrx/store';
import { CartActions, MultiCartService } from '@spartacus/cart/base/core';
import { AuthRedirectService, UserIdService } from '@spartacus/core';
import { Observable, take, tap } from 'rxjs';
import { CartExtendService } from 'src/app/service/cart/cart-extend.service';
import { StorageService } from 'src/app/service/storage/storage.service';
@Component({
  selector: 'app-unit-list',
  templateUrl: './unit-list.component.html',
  styleUrls: ['./unit-list.component.scss'],
  standalone: false,
})
export class UnitListComponent {
  @Input() list: any;

  get userCurrent(): string {
    let userCurrent: string;
    this.userIdService
      .getUserId()
      .pipe(take(1))
      .subscribe((userId) => (userCurrent = userId));
    return userCurrent;
  }

  constructor(
    private authRedirectService: AuthRedirectService,
    private storageService: StorageService,
    private cartExtendService: CartExtendService,
    protected store: Store<MultiCartService>,
    private userIdService: UserIdService,
    private multiCartService: MultiCartService
  ) {}

  setB2Bunit(unitId: any) {
    this.storageService.setLocalStorageitem('shimanoSessionB2BUnit', unitId);
    let shimanoSessionB2BUnit = this.storageService.getLocalStorageItem('shimanoSessionB2BUnit');
    if (shimanoSessionB2BUnit) {
      this.authRedirectService.redirect();
      this.loadCurrentCartAsActiveCart()
        .pipe(take(1))
        .subscribe({
          next: (res) => {},
          error: (err) => {
            if (this.isCartNotFound(err)) {
              this.multiCartService.createCart({
                userId: this.userCurrent,
                extraData: {
                  active: true,
                },
              });
            }
          },
        });
    }
  }

  loadCurrentCartAsActiveCart(): Observable<any> {
    return this.cartExtendService.getCurrentCart().pipe(
      tap((cart) => {
        this.store.dispatch(
          new CartActions.LoadCart({
            userId: this.userCurrent,
            cartId: cart.code,
            extraData: {
              active: true,
            },
          })
        );
      })
    );
  }

  isCartNotFound(res: HttpErrorResponse): boolean {
    return res.error?.errors[0]?.type === 'CartError' && res.error?.errors[0]?.reason === 'notFound';
  }
}
